import React from 'react';
import './_DownloadApp.scss';

class DownloadApp extends React.Component {

  render() {
    return (
      <div className='wrap-download-app'>
        <span className='download-app-text'>Download App:</span>
        <a href='#' className='download-app-icon'>
          <i className='fa fa-android'/>
        </a>
        <a href='#' className='download-app-icon'>
          <i className='fa fa-apple'/>
        </a>
        <a href='#' className='download-app-icon'>
          <i className='fa fa-windows'/>
        </a>
      </div>
    );
  }
}

export default DownloadApp;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/DownloadApp.jsx